export const unitySetSceneInformation = () => {
  (window as { [key: string]: any })["set_scene_information"] = (sceneName: any, isVideoConference: any, screenCount: any) => {
    console.log("Is Video Conference Scene: " + isVideoConference);
    console.log("Screen Count: " + screenCount);
    console.log("Scene Name: " + sceneName);
  };
};
